import { CoverageApiProvider } from '@newfront-insurance/coverage-ui';
import type { PropsWithChildren, JSX } from 'react';

export function AccountsCoverageApiProvider(props: PropsWithChildren<unknown>): JSX.Element {
  const { children } = props;
  return <CoverageApiProvider basePath="/api/coverage">{children}</CoverageApiProvider>;
}
